export default "__VITE_ASSET__Cv3FEIT2__"